import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import lgbl from "../../assets/images/CustomersPartners/lgbl.webp";
import { Navigation, Autoplay } from "swiper/modules";
import CustomerStory from "./CustomerStory";

import lgm from "../../assets/images/CustomersPartners/lgm.webp";

export default function CustomerCombat() {
  const images = [lgbl, lgbl, lgbl, lgbl, lgbl, lgbl];
  return (
    <div className="w-full">
      <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col gap-2">
        <div className="w-full flex flex-col gap-2 md:flex-col md:items-center md:justify-center ">
          <p className="text-[28px] md:text-[32px] text-[#333333] font-semibold">
            Đối tác chiến lược của{" "}
            <spam className="text-[#053CC8]">Blue Rise</spam>
          </p>
          <p className="text-[18px] text-[#606060] font-normal md:text-center">
            <spam className="text-[#053CC8] font-bold">Blue Rise</spam> tự hào
            hợp tác với các tổ chức giáo dục và công nghệ hàng đầu để mang đến
            những giải pháp tốt nhất cho ngành giáo dục. Chúng tôi luôn tìm kiếm
            các cơ hội hợp tác chiến lược nhằm nâng cao giá trị và mở rộng khả
            năng phục vụ khách hàng.
          </p>
        </div>
        <div>
          <div className="w-full">
            <div className="block md:hidden">
              <Swiper
                spaceBetween={10}
                slidesPerView={2}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                loop={true}
                modules={[Navigation, Autoplay]}
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image}
                      alt={`Slide ${index + 1}`}
                      className="w-full h-auto object-cover"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="hidden md:block bg-[#FAFAFA] p-7">
              <Swiper
                spaceBetween={180}
                slidesPerView={5}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                loop={true}
                modules={[Navigation, Autoplay]}
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image}
                      alt={`Slide ${index + 1}`}
                      className="w-full h-auto object-cover"
                      onMouseEnter={(e) => (e.currentTarget.src = lgm)}
                      onMouseLeave={(e) => (e.currentTarget.src = lgbl)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      <div>
        <CustomerStory />
      </div>
    </div>
  );
}
